/*
  RevoRope — "el giro": la máquina gira según el scroll (Home v5.1).

  Además de pintar el giro, este controlador releva los MENSAJES del hero
  (titular + entradilla) a medida que la máquina da la vuelta: el mensaje que
  está sale hacia arriba y el siguiente entra desde abajo. El reparto es por
  tramos iguales del recorrido, con histéresis. Toda la animación es CSS
  (.rr-hero__mensaje en home.css); aquí sólo se mueven dos clases.
  Si el hero usa media alternativa (vídeo/foto) no hay giro, así que este archivo
  sale antes de tiempo y se queda el primer mensaje: es lo correcto, los mensajes
  narran el giro.

  Secuencia de 90 fotogramas sacados del giro fotográfico real de la ficha Tech
  (media-pendiente/_test_ia_tech/tech_giro_minimax_2k_10s.mp4): NO es un render.
  Cubre ~180°, de la cara del wordmark (fotograma 089, el de reposo) a la del
  rotor rojo (fotograma 000). El fondo de estudio se recortó con birefnet-general,
  así que llevan canal alfa y la máquina flota sobre el negro de la propia página:
  no hay tarjeta, ni marco, ni recuadro más claro.

  OJO al sustituir la secuencia: al ser ~180° y no una vuelta entera, el recorrido
  NO es cíclico — indiceDe() acota en los extremos en vez de dar la vuelta. Si
  algún día se vuelve a una secuencia de 360°, ese acotado se puede quitar.

  Técnica: se pintan fotogramas en un <canvas> según la posición de scroll. NO se
  usa video.currentTime — un vídeo no busca fotograma a fotograma sin tirones, y
  menos hacia atrás. Esta es la misma técnica que usan las fichas de producto de
  Apple/Sony y la que ya estaba anotada como la correcta para este proyecto.

  Contrato con el resto del sistema (igual que rr-reveal.js / rr-cabo.js):
   - Sólo se mueve bajo html.rr-anim (la pone el script en línea de <head> cuando
     prefers-reduced-motion NO está activo) y se revalida aquí con matchMedia.
   - Sin JS, o con movimiento reducido, el <img> del fotograma de reposo se queda
     visible: el hero nunca se queda en blanco.
   - No toca rr-nav.js, rr-carousel.js, rr-reveal.js ni rr-cabo.js.

  Sobre el listener de scroll: es la única vía posible aquí (animation-timeline
  de CSS no puede pintar en un canvas). Se mitiga igual que en rr-cabo.js:
  listener pasivo + una sola lectura por fotograma vía requestAnimationFrame +
  IntersectionObserver que apaga el trabajo cuando el hero no está en pantalla.
*/
(function () {
  'use strict';

  var root = document.documentElement;
  var stage = document.querySelector('[data-rr-giro]');
  if (!stage || !window.requestAnimationFrame) return;

  var canvas = stage.querySelector('[data-rr-giro-lienzo]');
  var poster = stage.querySelector('[data-rr-giro-poster]');
  var fuente = document.querySelector('[data-rr-giro-frames]');
  if (!canvas || !canvas.getContext || !fuente) return;

  var urls;
  try {
    urls = JSON.parse(fuente.textContent);
  } catch (e) {
    return;
  }
  var N = urls.length;
  if (N < 2) return;

  var hero = stage.closest('.rr-hero');
  var inner = hero ? hero.querySelector('.rr-hero__inner') : null;
  var regla = hero ? hero.querySelector('.rr-hero__datos') : null;
  var cabecera = document.querySelector('.rr-header');
  if (!hero || !inner) return;

  // Mensajes que cambian con el giro (titular + entradilla). Si hay menos de dos
  // no hay nada que relevar y el hero se queda con el primero, que ya viene con
  // is-activo desde el servidor.
  var mensajes = hero.querySelectorAll('[data-rr-hero-mensaje]');
  var msgActual = 0;
  var MSG_MARGEN = 0.02; // histéresis: evita el parpadeo justo en el umbral

  // Fotograma de reposo: el que se ve sin haber hecho scroll y el que queda con
  // movimiento reducido. Es el mejor plano de producto de la vuelta (3/4 con el
  // rotor rojo abierto), no el 0 por defecto.
  var INICIO = parseInt(stage.getAttribute('data-rr-giro-inicio'), 10);
  if (isNaN(INICIO)) INICIO = 0;
  INICIO = Math.min(N - 1, Math.max(0, INICIO));

  // Amplitud del gesto de entrada, en fotogramas (6 = 24°). Es un tanteo de ida y
  // vuelta que ARRANCA Y TERMINA en el fotograma de reposo, no un viaje hasta él:
  // si empezara en otro ángulo habría un salto visible en el relevo del <img> al
  // canvas (medido: salto de 40° a los ~415ms en la primera versión).
  var ENTRADA = 6;
  var MARCA = 26; // alto de la marca roja de la barra, en px (ver home.css)

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var animar = root.classList.contains('rr-anim') && !reduce;

  var ctx = canvas.getContext('2d');
  var imgs = new Array(N);
  var pedido = new Array(N);
  var dibujado = -1;
  var listo = false;
  var entrando = false;
  var visible = true;
  var pendiente = false;
  var cw = 0;
  var ch = 0;
  var med = { ini: 0, largo: 1, barraY: 0 };

  /* ------------------------------------------------------------------ carga */

  function carga(i, prioridad) {
    if (pedido[i]) return pedido[i];
    var im = new Image();
    im.decoding = 'async';
    if (prioridad) {
      try {
        im.fetchPriority = prioridad;
      } catch (e) {}
    }
    var p = new Promise(function (res) {
      im.onload = function () {
        imgs[i] = im;
        res(i);
      };
      im.onerror = function () {
        res(-1);
      };
    });
    im.src = urls[i];
    pedido[i] = p;
    return p;
  }

  // Reaprovecha el <img> del fotograma de reposo (ya lo pidió el preescáner del
  // navegador con fetchpriority alto): así el canvas puede pintar sin esperar a
  // una segunda petición del mismo archivo.
  function adoptaPoster() {
    if (!poster || pedido[INICIO]) return;
    if (poster.complete && poster.naturalWidth) {
      imgs[INICIO] = poster;
      pedido[INICIO] = Promise.resolve(INICIO);
    }
  }

  // Fotogramas que recorre el gesto de entrada: del de reposo hacia donde gira el
  // scroll (índice decreciente).
  function listaEntrada() {
    var l = [];
    for (var k = 0; k <= ENTRADA; k++) l.push(((INICIO - k) % N + N) % N);
    return l;
  }

  // Dos olas. La primera deja la vuelta ENTERA navegable en ~26 archivos (los de
  // la entrada + uno de cada seis); la segunda rellena el resto y la afina. Entre
  // medias se pinta el fotograma cargado más cercano al objetivo, así que el giro
  // responde al scroll desde el principio en vez de esperar a los 90.
  function olas() {
    var vistos = {};
    var ola1 = [];
    function mete(i) {
      var k = ((i % N) + N) % N;
      if (!vistos[k]) {
        vistos[k] = 1;
        ola1.push(k);
      }
    }
    listaEntrada().forEach(mete);
    for (var j = 6; j < N; j += 6) mete(INICIO - j);

    var resto = [];
    for (var i = 0; i < N; i++) if (!vistos[i]) resto.push(i);

    Promise.all(
      ola1.map(function (i) {
        return carga(i, 'high');
      })
    ).then(function () {
      pintaObjetivo();
      cola(resto, 6);
    });

    // Salvavidas: si algo de la ola 1 no resuelve, el resto entra igualmente.
    setTimeout(function () {
      cola(resto, 4);
    }, 2500);
  }

  var colaActiva = false;
  function cola(lista, simultaneas) {
    if (colaActiva || !lista.length) return;
    colaActiva = true;
    var n = 0;
    function siguiente() {
      if (n >= lista.length) return;
      var i = lista[n++];
      carga(i, 'low').then(function () {
        // Repinta sólo si el que acaba de llegar es mejor que el que hay puesto.
        if (i === objetivoActual()) pintaObjetivo();
        siguiente();
      });
    }
    for (var s = 0; s < simultaneas; s++) siguiente();
  }

  /* ------------------------------------------------------------------ pintar */

  function cercano(i) {
    if (imgs[i]) return i;
    var tope = Math.ceil(N / 2);
    for (var d = 1; d <= tope; d++) {
      var a = ((i - d) % N + N) % N;
      if (imgs[a]) return a;
      var b = (i + d) % N;
      if (imgs[b]) return b;
    }
    return -1;
  }

  function dimensiona() {
    var r = canvas.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.round(r.width * dpr);
    var h = Math.round(r.height * dpr);
    if (w === canvas.width && h === canvas.height) return false;
    canvas.width = w;
    canvas.height = h;
    cw = w;
    ch = h;
    dibujado = -1;
    return true;
  }

  function pinta(i) {
    var j = cercano(i);
    if (j < 0) return;
    if (!cw) dimensiona();
    if (!cw) return;
    if (j === dibujado) return;
    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(imgs[j], 0, 0, cw, ch);
    dibujado = j;
    if (!listo) {
      listo = true;
      stage.classList.add('is-listo');
    }
  }

  /* ------------------------------------------------------------- posiciones */

  function fijado() {
    return getComputedStyle(inner).position === 'sticky';
  }

  function mide() {
    var scroll = window.pageYOffset || root.scrollTop || 0;
    var hh = cabecera ? cabecera.getBoundingClientRect().height : 0;

    if (fijado()) {
      // Con el hero fijado, la carrera de scroll es la altura sobrante de la
      // sección por debajo de lo que ocupa el panel fijado.
      med.ini = hero.getBoundingClientRect().top + scroll - hh;
      med.largo = Math.max(1, hero.offsetHeight - inner.offsetHeight);
    } else {
      // Sin fijar (móvil/tablet, ventanas bajas): la vuelta transcurre mientras
      // la platina cruza la pantalla. El 0,7 es a propósito: si la carrera fuera
      // el alto entero de la platina, la vuelta terminaría justo cuando la
      // máquina acaba de salir por arriba y los últimos ángulos no se verían.
      // Así cierra con un 30% de la platina todavía en pantalla.
      var r = stage.getBoundingClientRect();
      med.ini = Math.max(0, r.top + scroll - hh);
      med.largo = Math.max(1, r.height * 0.7);
    }

    // Recorrido de la marca roja: baja por la barra vertical de los datos.
    med.barraY = regla ? Math.max(0, regla.getBoundingClientRect().height - MARCA) : 0;
    dimensiona();
  }

  function progreso() {
    var s = window.pageYOffset || root.scrollTop || 0;
    var p = (s - med.ini) / med.largo;
    return p < 0 ? 0 : p > 1 ? 1 : p;
  }

  // El scroll hace DECRECER el índice a propósito: desde el fotograma de reposo,
  // lo primero que hace la máquina al bajar es abrir el rotor hacia el
  // espectador. La recompensa cae en el primer gesto, no al final.
  function indiceDe(p) {
    // Acotado, no cíclico: la secuencia cubre ~180°, así que dar la vuelta
    // produciría un salto duro de media vuelta a mitad de scroll.
    var i = INICIO - Math.round(p * (N - 1));
    return i < 0 ? 0 : i > N - 1 ? N - 1 : i;
  }

  function objetivoActual() {
    return indiceDe(progreso());
  }

  /* ------------------------------------------------------------- mensajes */

  /* A qué mensaje toca según el progreso del giro. La tirada se reparte en
     tramos iguales, con un margen de histéresis para que un temblor del scroll
     justo en el umbral no haga parpadear el relevo: el cambio sólo ocurre
     cuando el progreso pasa el umbral CON margen, y en el sentido en el que se
     está yendo. */
  function mensajeDe(p, actual) {
    var n = mensajes.length;
    if (n < 2) return 0;
    var ancho = 1 / n;
    var i = actual;
    while (i < n - 1 && p >= (i + 1) * ancho + MSG_MARGEN) i++;
    while (i > 0 && p < i * ancho - MSG_MARGEN) i--;
    return i;
  }

  /* is-activo = el que se ve. is-pasado = los que ya han salido, que esperan
     ARRIBA; los que todavía no han entrado esperan ABAJO (es el estado por
     defecto en CSS). Así el mensaje que se va sale hacia arriba y el que llega
     entra desde abajo, y al subir por la página pasa exactamente lo contrario
     sin ninguna lógica extra. */
  function aplicaMensaje(m) {
    msgActual = m;
    for (var i = 0; i < mensajes.length; i++) {
      var el = mensajes[i];
      el.classList.toggle('is-activo', i === m);
      el.classList.toggle('is-pasado', i < m);
    }
  }

  function pintaObjetivo() {
    var p = progreso();
    if (regla) regla.style.setProperty('--rr-giro-y', (p * med.barraY).toFixed(1) + 'px');
    if (mensajes.length > 1) {
      var m = mensajeDe(p, msgActual);
      if (m !== msgActual) aplicaMensaje(m);
    }
    pinta(indiceDe(p));
  }

  function alScroll() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      if (!visible || entrando) return;
      pintaObjetivo();
    });
  }

  /* ------------------------------------------------------------- entrada */

  // Al cargar, la máquina se asoma ~24° en el sentido en que la va a girar el
  // scroll y vuelve a su sitio. Es la única señal de que el objeto se mueve, y de
  // paso adelanta hacia dónde gira; sin ella haría falta un indicador ("desliza"),
  // que es justo el tipo de chapa que este hero no lleva.
  //
  // sin(pi*k) da 0 -> 1 -> 0 con las dos puntas planas: sale y vuelve sin tirones
  // y sin rebote, y termina exactamente en el fotograma de reposo, que es el que
  // ya estaba pintado. Por eso no hay ningún salto en el relevo del <img>.
  function entrada() {
    if (!animar || entrando || (window.pageYOffset || 0) > 4) {
      alScroll();
      return;
    }
    entrando = true;
    var t0 = 0;
    var DUR = 1600;
    function paso(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / DUR);
      // Si el visitante se pone a hacer scroll, el gesto sobra: manda él.
      if ((window.pageYOffset || 0) > 4) {
        entrando = false;
        alScroll();
        return;
      }
      pinta(((INICIO - Math.round(ENTRADA * Math.sin(Math.PI * k))) % N + N) % N);
      if (k < 1) {
        requestAnimationFrame(paso);
      } else {
        entrando = false;
        alScroll();
      }
    }
    requestAnimationFrame(paso);
  }

  /* ------------------------------------------------------------- arranque */

  adoptaPoster();
  mide();

  if (!animar) {
    // Movimiento reducido: un solo fotograma, el de reposo, y ni un listener.
    carga(INICIO, 'high').then(function () {
      pinta(INICIO);
    });
    return;
  }

  // Pinta en cuanto haya algo que pintar, sin esperar a ninguna ola.
  carga(INICIO, 'high').then(function () {
    if (!listo) pinta(INICIO);
  });

  // La entrada espera a SUS fotogramas: si arrancara sólo con el de reposo
  // cargado, cercano() devolvería ese mismo en todo el recorrido y el giro de
  // entrada no se vería (pasó en la primera verificación). Con tope de 1,2s para
  // que una red lenta no deje al hero sin su gesto de arranque: lo que haya
  // cargado para entonces ya sirve, y el resto entra sobre la marcha.
  Promise.race([
    Promise.all(
      listaEntrada().map(function (i) {
        return carga(i, 'high');
      })
    ),
    new Promise(function (r) {
      setTimeout(r, 1200);
    })
  ]).then(entrada);

  olas();

  window.addEventListener('scroll', alScroll, { passive: true });

  var rt;
  function reajusta() {
    clearTimeout(rt);
    rt = setTimeout(function () {
      mide();
      dibujado = -1;
      alScroll();
    }, 120);
  }
  window.addEventListener('resize', reajusta, { passive: true });
  window.addEventListener('orientationchange', reajusta, { passive: true });
  window.addEventListener('load', function () {
    mide();
    alScroll();
  });
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(reajusta);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entradas) {
        visible = entradas[0].isIntersecting;
        if (visible) alScroll();
      },
      { rootMargin: '250px 0px' }
    ).observe(hero);
  }
})();
